// resolves only in apps/ui; typed elsewhere by the fallback contract in #core/types/advisor-portal
import { useAdvisor } from '#advisor-portal/state/useAdvisor'
import { useMounted } from '@vueuse/core'

function isHomeLanding(currentPath: string) {
  return currentPath === '/'
}

export function useHomeNavLink() {
  const auth = useAuth()
  const advisor = useAdvisor()
  // The server renders signed out, so the signed-in link must wait until after hydration.
  const mounted = useMounted()

  return computed(() => {
    if (!mounted.value) {
      return { label: 'Home', to: '/', shouldHighlight: isHomeLanding }
    }

    if (advisor.isAdvisorDefault) {
      return { label: 'Home & Engagements', to: '/advisor-portal', exact: true }
    }

    if (!auth.isLoggedIn) {
      return { label: 'Home', to: '/', shouldHighlight: isHomeLanding }
    }

    const project = auth.isAdvisor ? advisor.project : null
    return {
      label: project ? `${project.name} Home` : 'Home',
      to: auth.project ? `/project/${auth.project.id}` : '/',
      exact: true,
      shouldHighlight: isHomeLanding,
    }
  })
}
